import { Pagination } from '@/domain/entities/Pagination'
import { Homebanner, HomebannerData } from '@/domain/entities/Homebanner'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './Base'

export class HomebannerDataMapper extends BaseResponseMapper {
  public convertHomebannerFromApi(result: AxiosResponse<any>): Homebanner {
    const { data } = result
    return new Homebanner(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new HomebannerData(
            val.id,
            val.name,
            val.image,
            val.created_at,
            val.updated_at
          )
      )
    )
  }
}
